const parseJson = require("./parseJson");

/**
 * @param json {string}
 * @return {unknown}
 */
module.exports = function parseJsonBoolean(json) {
    const value = parseJson(json);

    if (typeof value === "boolean") {
        return value;
    }

    return false;
}
